import React, { useState, useEffect, useRef } from "react";
import {
  Accordion,
  Card,
  UnstyledButton,
  Grid,
  Text,
  Box,
  useMantineTheme,
  List,
  ActionIcon,
  CloseButton,
  Title,
  TextInput,
  Button,
  Tooltip,
} from "@mantine/core";
import * as dayjs from "dayjs";
import { useSetState } from "@mantine/hooks";
import FormField from "../FormBuilder/FormField";
import EditFormField from "./EditFormField";
import { showNotification } from "@mantine/notifications";
import { IconPlus, IconMenu2, IconHistory } from "@tabler/icons";
// jquery Sortable component
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import { useParams } from "react-router-dom";
import AddField from "../FormBuilder/Modals/AddField";
import { apiWithInterceptor } from "../../../../api";

const EditFormModal = () => {
  const { formId } = useParams();
  const fieldsListRef = useRef();
  const sortableInit = useRef(false);
  const [addFieldModalState, setAddFieldModalState] = useState(false);
  const [formName, setFormname] = useState("");
  const [formInfo, setFormInfo] = useState({});
  const [updateFields, setUpdateFields] = useState([]);

  // Setting the field object values
  const [fieldsObj, setFieldsObj] = useSetState({
    fields: {},
    ids: [],
  });

  // const memoizedState = useMemo(() => {
  //   return { ...fieldsObj };
  // }, [fieldsObj]);

  const theme = useMantineTheme();

  const regexExp =
    /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

  // const getFields = () => {
  //   return Object.keys(fieldsObj.fields).map((key) => {
  //     return fieldsObj.fields[key];
  //   });
  // };

  useEffect(() => {
    apiWithInterceptor
      .get(`/form/${formId}?relations[]=fields.answers`)
      .then((res) => {
        setFormInfo(res.data);
        setFormname(res.data.name);

        setFieldsObj(
          res.data.fields.reduce(
            (p, field) => ({
              fields: {
                [`field_${p.ids.length}`]: {
                  ...field,
                  oldId: field.id,
                  id: `field_${p.ids.length}`,
                },
                ...p.fields,
              },
              ids: [...p.ids, `field_${p.ids.length}`],
            }),
            {
              fields: {},
              ids: [],
            }
          )
        );
      });
  }, []);

  useEffect(() => {
    if (sortableInit.current) {
      $(fieldsListRef.current).sortable("refresh");
    } else {
      $(fieldsListRef.current).sortable({
        items: ">li",
        stop: (event, ui) => {
          const newOrder = $(fieldsListRef.current).sortable("toArray", {
            attribute: "id",
          });
          setFieldsOrder(newOrder);
        },
      });
      sortableInit.current = true;
    }
  }, [fieldsObj.ids.length]);

  // Set the values that comes form the Field Form component

  function setFieldValues(id, values) {
    const { fields } = fieldsObj;
    setFieldsObj({
      fields: {
        ...fields,
        [id]: {
          ...fields[id],
          ...values,
        },
      },
    });
  }

  // Add new field to the fieldObj Object
  const addField = (field) => {
    const id = `field_${fieldsObj.ids.length}`;
    const fieldVal = { ...field };
    delete fieldVal.icon;
    fieldVal.data_type = fieldVal.dataType.toUpperCase();
    fieldVal.presentation = fieldVal.presentation.toUpperCase();
    const newField = {
      ...fieldVal,
      id,
    };

    const { fields, ids } = { ...fieldsObj };
    const newFields = {
      fields: {
        [id]: newField,
        ...fields,
      },
      ids: [...ids, id],
    };

    setFieldsObj(newFields);
  };

  // Remove the field form the fieldObj form the field Object
  function removeField() {
    if (arguments.length === 2) {
      delete fieldsObj.fields[arguments[0]];
      setFieldsObj({
        ids: fieldsObj.ids.filter((fieldId) => fieldId !== arguments[0]),
      });
      apiWithInterceptor
        .delete(`/field/${arguments[1]}`)
        .then(() => {
          showNotification({
            title: `Deleted`,
            message: "Field deleted successfuly",
            color: "green",
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (arguments.length === 1) {
      delete fieldsObj.fields[arguments[0]];
      setFieldsObj({
        ids: fieldsObj.ids.filter((fieldId) => fieldId !== arguments[0]),
      });
    }
  }

  // Set the new order to render in the fields component
  const setFieldsOrder = (newOrder) => {
    setFieldsObj({
      ids: newOrder,
    });
  };

  // Render the last fields order after implementing Jquery on the DOM
  useEffect(() => {
    let allFields = [];
    const { fields, ids } = fieldsObj;
    ids.forEach((id) => {
      allFields.push({ ...fields[id] });
    });
    allFields.map((item) => {
      if (item.oldId !== undefined) {
        item.id = item.oldId;
        delete item.oldId;
      } else {
        delete item.id;
      }
    });
    setUpdateFields(allFields);
  }, [fieldsObj]);

  // Sort the new order for the fields

  const handelSubmit = (e) => {
    e.preventDefault();

    apiWithInterceptor
      .patch(`/form/${formId}`, {
        fields: updateFields,
        name: formName,
      })
      .then(function (response) {
        showNotification({
          title: `${response?.request?.statusText}`,
          message: "Form Successfully Updated",
          color: "green",
        });
      })
      .catch(function (error) {
        console.log(error);
        showNotification({
          title: "Failed to update form",
          message: ` ${error?.response?.data?.message}`,
          color: "red",
        });
      });
  };

  return (
    <>
      <form
        onSubmit={(e) => {
          handelSubmit(e);
        }}
      >
        <Title mb={"md"} size="h2" order={1}>
          Editing ({formInfo?.name}) form
        </Title>
        <TextInput
          size="lg"
          label="Form Name"
          placeholder="Select a new form name"
          defaultValue={formInfo?.name}
          onChange={(e) => setFormname(e.target.value)}
          mb={"sm"}
        />

        <Text>Fields</Text>
        <List
          id="fields-list"
          ref={fieldsListRef}
          mb={"sm"}
          sx={{
            listStyle: "none",
            "&>*:not(last-child)": {
              marginBottom: "20px",
            },
          }}
        >
          {Object.keys(fieldsObj.fields)
            .map((id) => fieldsObj.fields[id])
            .reverse()
            .map((field) => (
              <List.Item
                id={field.id}
                key={field.id}
                sx={{ "& > *": { width: "100%" } }}
              >
                <Card withBorder p={0} sx={{ overflow: "visible" }}>
                  <Accordion chevronPosition="right" m={0} pl={"sm"} pr={"md"}>
                    <Accordion.Item value={field.id} sx={{ border: 0 }}>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Box
                          sx={{
                            cursor: "move",
                          }}
                        >
                          <IconMenu2 size={16} />
                        </Box>
                        <Accordion.Control py={15}>
                          <Text>{field.label}</Text>
                          <Text size="sm" color="dimmed" weight={400}>
                            {regexExp.test() ? field.type : field.presentation}
                          </Text>
                        </Accordion.Control>
                        <Tooltip
                          label={`Created At: ${dayjs(field.created_at).format(
                            "YYYY-MM-DD @ hh:mm"
                          )} ---- Updated At: ${dayjs(field.updated_at).format(
                            "YYYY-MM-DD @ hh:mm"
                          )}`}
                          withArrow
                        >
                          <ActionIcon size="lg">
                            <IconHistory width={"16px"} height={"16px"} />
                          </ActionIcon>
                        </Tooltip>
                        <ActionIcon size="lg">
                          <CloseButton
                            size="md"
                            onClick={() => {
                              if (field.oldId !== undefined) {
                                removeField(field.id, field.oldId);
                              } else {
                                removeField(field.id);
                              }
                            }}
                          />
                        </ActionIcon>
                      </Box>
                      <Accordion.Panel>
                        {field.oldId === undefined ? (
                          <>
                            <FormField
                              field={field}
                              setFieldValues={setFieldValues}
                            />
                          </>
                        ) : (
                          <>
                            <EditFormField
                              field={field}
                              setFieldValues={setFieldValues}
                            />
                          </>
                        )}
                      </Accordion.Panel>
                    </Accordion.Item>
                  </Accordion>
                </Card>
              </List.Item>
            ))}
        </List>
        <UnstyledButton
          sx={{ width: "100%", marginTop: "20px" }}
          onClick={() => {
            setAddFieldModalState(true);
          }}
        >
          <Card
            withBorder
            py={30}
            sx={{
              transition: ".3s",
              "&:hover": {
                borderColor: theme.colors.brand[4],
                backgroundColor: `${theme.colors.brand[9]}02`,
              },
              "&:hover *": {
                color: theme.colors.brand[5],
              },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <IconPlus />

              <Text ml={"xs"}>Add Field</Text>
            </Grid>
          </Card>
        </UnstyledButton>

        <AddField
          opened={addFieldModalState}
          onClose={() => {
            setAddFieldModalState(false);
          }}
          onFieldClick={(field) => {
            addField(field);
            setAddFieldModalState(false);
          }}
        />
        <Button mt={"lg"} type="submit">
          Update Form
        </Button>
      </form>
    </>
  );
};

export default EditFormModal;
